// Mantiene la posizione di scroll quando si cambia lingua (IT/EN)
const langSwitch = document.getElementById('langSwitch');
if (langSwitch) {
  langSwitch.querySelectorAll('.lang-option').forEach(btn => {
    btn.addEventListener('click', () => {
      sessionStorage.setItem('scrollPosBeforeLangSwitch', window.scrollY);
    });
  });
}
const savedScrollPos = sessionStorage.getItem('scrollPosBeforeLangSwitch');
if (savedScrollPos !== null) {
  sessionStorage.removeItem('scrollPosBeforeLangSwitch');
  window.scrollTo(0, parseInt(savedScrollPos, 10));
}

// Header on scroll
const header = document.getElementById('siteHeader');
window.addEventListener('scroll', () => {
  header.classList.toggle('scrolled', window.scrollY > 60);
}, {passive:true});

// Menu mobile
const mobileMenuToggle = document.getElementById('mobileMenuToggle');
const mobileMenu = document.getElementById('mobileMenu');
const mobileMenuOverlay = document.getElementById('mobileMenuOverlay');
const mobileMenuClose = document.getElementById('mobileMenuClose');

function openMobileMenu() {
  if (!mobileMenu) return;
  mobileMenu.classList.add('open');
  mobileMenu.setAttribute('aria-hidden', 'false');
  if (mobileMenuToggle) mobileMenuToggle.setAttribute('aria-expanded', 'true');
  document.body.style.overflow = 'hidden';
}
function closeMobileMenu() {
  if (!mobileMenu) return;
  mobileMenu.classList.remove('open');
  mobileMenu.setAttribute('aria-hidden', 'true');
  if (mobileMenuToggle) mobileMenuToggle.setAttribute('aria-expanded', 'false');
  document.body.style.overflow = '';
}
if (mobileMenuToggle) {
  mobileMenuToggle.addEventListener('click', () => {
    if (mobileMenu.classList.contains('open')) closeMobileMenu();
    else openMobileMenu();
  });
}
if (mobileMenuOverlay) mobileMenuOverlay.addEventListener('click', closeMobileMenu);
if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMobileMenu);
document.querySelectorAll('.mobile-menu-panel a').forEach(a => a.addEventListener('click', closeMobileMenu));
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('open')) closeMobileMenu();
});

// Reveal on scroll
const revealEls = document.querySelectorAll('.reveal');
const io = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if(e.isIntersecting){
      e.target.classList.add('in');
      io.unobserve(e.target);
    }
  });
}, {threshold:0.05, rootMargin:'0px 0px -10px 0px'});
revealEls.forEach(el => io.observe(el));

// Lacci interactive swatches
const swatches = document.querySelectorAll('.swatch');
const captionText = document.getElementById('lacci-caption-text');
const lacciSection = document.querySelector('.lacci-section');
const lacciPhoto = document.getElementById('lacciPhoto');

const lacciColors = {
  rosso: 'var(--lace-red)',
  marrone: 'var(--lace-brown)',
  giallo: 'var(--lace-yellow)'
};

// Precarica in background le foto di ogni colore laccio, così il click sullo
// swatch cambia l'immagine subito invece di aspettare il download.
swatches.forEach(sw => {
  if (sw.dataset.image) {
    const preload = new Image();
    preload.src = sw.dataset.image;
  }
});

swatches.forEach(sw => {
  sw.addEventListener('click', () => {
    swatches.forEach(s => s.classList.remove('active'));
    sw.classList.add('active');
    const key = sw.dataset.color;
    lacciSection.style.setProperty('--accent', lacciColors[key]);
    if (lacciPhoto && sw.dataset.image) {
      lacciPhoto.src = sw.dataset.image;
    }
    captionText.style.opacity = 0;
    setTimeout(() => {
      captionText.textContent = sw.dataset.caption;
      captionText.style.opacity = 1;
    }, 180);
  });
});

// Filtro genere nella griglia colori
document.querySelectorAll('.colori-filter-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.colori-filter-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const filter = btn.dataset.filter;
    document.querySelectorAll('.colore-card').forEach(card => {
      if (filter === 'tutti') {
        card.style.display = '';
        return;
      }
      const matches = filter === 'uomo' ? card.dataset.genderUomo === 'true' : card.dataset.genderDonna === 'true';
      card.style.display = matches ? '' : 'none';
    });
  });
});

// AJAX add-to-cart: aggiunge il prodotto senza allontanare il cliente dalla pagina
function updateCartCount(count) {
  const link = document.querySelector('.cart-link');
  if (!link) return;
  let badge = link.querySelector('.cart-count');
  if (count > 0) {
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'cart-count';
      link.appendChild(badge);
    }
    badge.textContent = count;
  } else if (badge) {
    badge.remove();
  }
}

// Cart drawer: mostra il carrello in un pannello laterale invece di cambiare pagina
const cartDrawer = document.getElementById('cartDrawer');
const cartDrawerBody = document.getElementById('cartDrawerBody');
const cartDrawerFooter = document.getElementById('cartDrawerFooter');
const cartDrawerSubtotal = document.getElementById('cartDrawerSubtotal');

function openCartDrawer() {
  if (!cartDrawer) return;
  cartDrawer.classList.add('open');
  cartDrawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function closeCartDrawer() {
  if (!cartDrawer) return;
  cartDrawer.classList.remove('open');
  cartDrawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

function renderCartDrawer(cart) {
  if (!cartDrawerBody) return;
  const emptyText = (cartDrawer && cartDrawer.dataset.emptyText) || 'Il carrello è vuoto.';
  const sizeLabel = (cartDrawer && cartDrawer.dataset.sizeLabel) || 'Taglia';
  const qtyLabel = (cartDrawer && cartDrawer.dataset.qtyLabel) || 'Quantità';
  const removeLabel = (cartDrawer && cartDrawer.dataset.removeLabel) || 'Rimuovi';
  if (cart.item_count === 0) {
    cartDrawerBody.innerHTML = `<p class="cart-drawer-empty">${emptyText}</p>`;
    if (cartDrawerFooter) cartDrawerFooter.hidden = true;
    return;
  }
  cartDrawerBody.innerHTML = cart.items.map(item => `
    <div class="cart-drawer-item">
      <img src="${item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : ''}" alt="${item.product_title}">
      <div class="cart-drawer-item-info">
        <div class="cart-drawer-item-title">${item.product_title}</div>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-drawer-item-variant">${sizeLabel}: ${item.variant_title}</div>` : ''}
        <div class="cart-drawer-item-qty">${qtyLabel}: ${item.quantity}</div>
      </div>
      <div class="cart-drawer-item-end">
        <button type="button" class="cart-drawer-item-remove" data-key="${item.key}" aria-label="${removeLabel}: ${item.product_title}">&times;</button>
        <div class="cart-drawer-item-price">${formatMoney(item.final_line_price)}</div>
      </div>
    </div>
  `).join('');
  if (cartDrawerFooter) cartDrawerFooter.hidden = false;
  if (cartDrawerSubtotal) cartDrawerSubtotal.textContent = formatMoney(cart.items_subtotal_price);

  cartDrawerBody.querySelectorAll('.cart-drawer-item-remove').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.disabled = true;
      fetch(cartUrl('cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
      })
        .then(res => res.json())
        .then(cart => {
          updateCartCount(cart.item_count);
          renderCartDrawer(cart);
        })
        .catch(() => { btn.disabled = false; });
    });
  });
}

// Usa lo stesso formato valuta dello store (shop.money_format), così i prezzi del
// drawer coincidono con quelli generati da Liquid con il filtro | money. Prima
// veniva usato toLocaleString sulla lingua della pagina: in inglese produceva
// €450.00 mentre il resto della pagina mostrava €450,00.
function formatMoney(cents) {
  const format = (cartDrawer && cartDrawer.dataset.moneyFormat) || '€{{amount_with_comma_separator}}';
  const value = cents / 100;

  function withDelimiters(number, precision, thousands, decimal) {
    const parts = number.toFixed(precision).split('.');
    const intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return intPart + (parts[1] ? decimal + parts[1] : '');
  }

  return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, placeholder) {
    switch (placeholder) {
      case 'amount_no_decimals': return withDelimiters(value, 0, ',', '');
      case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', '');
      case 'amount_with_apostrophe_separator': return withDelimiters(value, 2, "'", '.');
      default: return withDelimiters(value, 2, ',', '.');
    }
  });
}

function cartUrl(path) {
  const root = (cartDrawer && cartDrawer.dataset.localeRoot) || '/';
  return root + path;
}

function refreshCartDrawer() {
  return fetch(cartUrl('cart.js'))
    .then(res => res.json())
    .then(cart => {
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
      return cart;
    });
}

const cartIconLink = document.getElementById('cartIconLink');
if (cartIconLink) {
  cartIconLink.addEventListener('click', (e) => {
    e.preventDefault();
    refreshCartDrawer();
    openCartDrawer();
  });
}

const cartDrawerClose = document.getElementById('cartDrawerClose');
if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);

const cartDrawerOverlay = document.getElementById('cartDrawerOverlay');
if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCartDrawer);

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('open')) closeCartDrawer();
});

document.querySelectorAll('.ajax-add-form').forEach(form => {
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const submitBtn = form.querySelector('button[type="submit"]');
    const originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = submitBtn.dataset.loadingText || originalText;
    }
    fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    })
      .then(res => res.ok ? res.json() : res.json().then(err => { throw err; }))
      .then(() => refreshCartDrawer())
      .then(() => {
        openCartDrawer();
        if (submitBtn) {
          submitBtn.textContent = submitBtn.dataset.successText || originalText;
          setTimeout(() => {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }, 1800);
        }
      })
      .catch(err => {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
        alert((err && err.description) || (submitBtn && submitBtn.dataset.errorText) || 'Prodotto non disponibile nella quantità richiesta.');
      });
  });
});
